import { Observable } from "rxjs";

export  function extractNodes() {
  return function<T>(source: Observable<any>): Observable<Array<T>> {
    return new Observable(subscriber => {
      source.subscribe({
        next(value) {
          subscriber.next(value.map((edge: any) => edge.node));
        },
        error(error) {
          subscriber.error(error);
        },
        complete() {
          subscriber.complete();
        }
      })
    });
  }
}
